export default function ProjsSAPText(){
  return(
    <div>
      SAP Text coming soon! 
    </div>
  );
}